/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'chat.bsky.moderation.subscribeModEvents'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $message = /*#__PURE__*/ l.typedUnion(
  [
    /*#__PURE__*/ l.typedRef<EventConvoFirstMessage>(
      (() => eventConvoFirstMessage) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatCreated>(
      (() => eventGroupChatCreated) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatMemberAdded>(
      (() => eventGroupChatMemberAdded) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatMemberJoined>(
      (() => eventGroupChatMemberJoined) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatJoinRequest>(
      (() => eventGroupChatJoinRequest) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatJoinRequestApproved>(
      (() => eventGroupChatJoinRequestApproved) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatJoinRequestRejected>(
      (() => eventGroupChatJoinRequestRejected) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventChatAccepted>(
      (() => eventChatAccepted) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatMemberLeft>(
      (() => eventGroupChatMemberLeft) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventGroupChatUpdated>(
      (() => eventGroupChatUpdated) as any,
    ),
    /*#__PURE__*/ l.typedRef<EventRateLimitExceeded>(
      (() => eventRateLimitExceeded) as any,
    ),
  ],
  false,
)

export type $Message = l.InferOutput<typeof $message>

/** Subscribe to stream of chat events targeted to moderation. Private endpoint. */
const main = /*#__PURE__*/ l.subscription($nsid, $params, $message, [
  'FutureCursor',
  'ConsumerTooSlow',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

/** Fired when a user accepts a chat convo, either explicitly or by sending a message. */
type EventChatAccepted = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventChatAccepted'
  rev: string

  /**
   * How the convo was accepted.
   */
  method: 'explicit' | 'message' | l.UnknownString
  convoId: string

  /**
   * The DID of the person accepting the convo.
   */
  actorDid: l.DidString

  /**
   * The DID of the group chat owner. Only present for group convos.
   */
  ownerDid?: l.DidString
  createdAt: l.DatetimeString

  /**
   * The name of the group chat. Only present for group convos.
   */
  groupName?: string

  /**
   * When the convo was originally created.
   */
  convoCreatedAt: l.DatetimeString

  /**
   * Current member count at the time of the event. Only present for group convos.
   */
  groupMemberCount?: number
}

export type { EventChatAccepted }

/** Fired when a user accepts a chat convo, either explicitly or by sending a message. */
const eventChatAccepted = /*#__PURE__*/ l.typedObject<EventChatAccepted>(
  $nsid,
  'eventChatAccepted',
  /*#__PURE__*/ l.object({
    rev: /*#__PURE__*/ l.string(),
    method: /*#__PURE__*/ l.string<{ knownValues: ['explicit', 'message'] }>(),
    convoId: /*#__PURE__*/ l.string(),
    actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
    ownerDid: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'did' }),
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    groupName: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    groupMemberCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { eventChatAccepted }

/** Fire when a group chat is created. */
type EventGroupChatCreated = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatCreated'
  rev: string
  convoId: string

  /**
   * The DID of the actor performing the action. For this event, same as ownerDid.
   */
  actorDid: l.DidString

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  createdAt: l.DatetimeString

  /**
   * The name set at creation time.
   */
  groupName: string

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number

  /**
   * DIDs of everyone added at creation time.
   */
  initialMemberDids: l.DidString[]
}

export type { EventGroupChatCreated }

/** Fire when a group chat is created. */
const eventGroupChatCreated =
  /*#__PURE__*/ l.typedObject<EventGroupChatCreated>(
    $nsid,
    'eventGroupChatCreated',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      convoId: /*#__PURE__*/ l.string(),
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupName: /*#__PURE__*/ l.string(),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
      initialMemberDids: /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.string({ format: 'did' }),
      ),
    }),
  )

export { eventGroupChatCreated }

/** Fired when a group chat's metadata or status changes. */
type EventGroupChatUpdated = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatUpdated'
  rev: string
  convoId: string

  /**
   * The new group name. Only present when updateType is 'name_changed'.
   */
  newName?: string

  /**
   * The previous group name. Only present when updateType is 'name_changed'.
   */
  oldName?: string

  /**
   * The DID of the actor performing the action (the owner).
   */
  actorDid: l.DidString

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  createdAt: l.DatetimeString

  /**
   * Current group name.
   */
  groupName: string

  /**
   * Why the group was locked. Only present when updateType is 'locked'.
   */
  lockReason?:
    | 'owner_action'
    | 'owner_left'
    | 'owner_deactivated'
    | 'owner_deleted'
    | 'owner_suspended'
    | 'owner_taken_down'
    | 'label_applied'
    | 'convo_taken_down'
    | l.UnknownString

  /**
   * What changed.
   */
  updateType:
    | 'name_changed'
    | 'locked'
    | 'locked_permanently'
    | 'unlocked'
    | 'join_link_created'
    | 'join_link_disabled'
    | 'join_link_settings_changed'
    | l.UnknownString

  /**
   * The code of the join link. Only present when updateType is join-link-related.
   */
  joinLinkCode?: string

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number

  /**
   * Whether the join link is restricted to followers of the owner. Only present when updateType is join-link-related.
   */
  joinLinkFollowersOnly?: boolean

  /**
   * Whether the join link requires owner approval to join. Only present when updateType is join-link-related.
   */
  joinLinkRequiresApproval?: boolean
}

export type { EventGroupChatUpdated }

/** Fired when a group chat's metadata or status changes. */
const eventGroupChatUpdated =
  /*#__PURE__*/ l.typedObject<EventGroupChatUpdated>(
    $nsid,
    'eventGroupChatUpdated',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      convoId: /*#__PURE__*/ l.string(),
      newName: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      oldName: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupName: /*#__PURE__*/ l.string(),
      lockReason: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.string<{
          knownValues: [
            'owner_action',
            'owner_left',
            'owner_deactivated',
            'owner_deleted',
            'owner_suspended',
            'owner_taken_down',
            'label_applied',
            'convo_taken_down',
          ]
        }>(),
      ),
      updateType: /*#__PURE__*/ l.string<{
        knownValues: [
          'name_changed',
          'locked',
          'locked_permanently',
          'unlocked',
          'join_link_created',
          'join_link_disabled',
          'join_link_settings_changed',
        ]
      }>(),
      joinLinkCode: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
      joinLinkFollowersOnly: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.boolean(),
      ),
      joinLinkRequiresApproval: /*#__PURE__*/ l.optional(
        /*#__PURE__*/ l.boolean(),
      ),
    }),
  )

export { eventGroupChatUpdated }

/** Fired when the first message was sent on a convo. */
type EventConvoFirstMessage = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventConvoFirstMessage'
  rev: string

  /**
   * The DID of the message author.
   */
  user: l.DidString
  convoId: string
  createdAt: l.DatetimeString
  messageId?: string

  /**
   * The list of DIDs message recipients. Does not include the sender, which is in the `user` field
   */
  recipients: l.DidString[]
}

export type { EventConvoFirstMessage }

/** Fired when the first message was sent on a convo. */
const eventConvoFirstMessage =
  /*#__PURE__*/ l.typedObject<EventConvoFirstMessage>(
    $nsid,
    'eventConvoFirstMessage',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      user: /*#__PURE__*/ l.string({ format: 'did' }),
      convoId: /*#__PURE__*/ l.string(),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      messageId: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
      recipients: /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.string({ format: 'did' }),
      ),
    }),
  )

export { eventConvoFirstMessage }

/** Fired when a user exceeds a rate limit. */
type EventRateLimitExceeded = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventRateLimitExceeded'
  rev: string

  /**
   * The DID of the user who hit the rate limit.
   */
  actorDid: l.DidString

  /**
   * The NSID of the endpoint that was rate limited.
   */
  endpoint: string
  createdAt: l.DatetimeString
}

export type { EventRateLimitExceeded }

/** Fired when a user exceeds a rate limit. */
const eventRateLimitExceeded =
  /*#__PURE__*/ l.typedObject<EventRateLimitExceeded>(
    $nsid,
    'eventRateLimitExceeded',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      endpoint: /*#__PURE__*/ l.string(),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    }),
  )

export { eventRateLimitExceeded }

/** Fired when a member leaves or is removed from a group chat. */
type EventGroupChatMemberLeft = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatMemberLeft'
  rev: string
  convoId: string

  /**
   * The DID of the actor. For voluntary: the person leaving. For kicked: the owner.
   */
  actorDid: l.DidString

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  createdAt: l.DatetimeString
  groupName: string

  /**
   * The DID of the member who left or was removed.
   */
  subjectDid: l.DidString

  /**
   * How the member left.
   */
  leaveMethod: 'voluntary' | 'kicked' | l.UnknownString

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number
}

export type { EventGroupChatMemberLeft }

/** Fired when a member leaves or is removed from a group chat. */
const eventGroupChatMemberLeft =
  /*#__PURE__*/ l.typedObject<EventGroupChatMemberLeft>(
    $nsid,
    'eventGroupChatMemberLeft',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      convoId: /*#__PURE__*/ l.string(),
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupName: /*#__PURE__*/ l.string(),
      subjectDid: /*#__PURE__*/ l.string({ format: 'did' }),
      leaveMethod: /*#__PURE__*/ l.string<{
        knownValues: ['voluntary', 'kicked']
      }>(),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
    }),
  )

export { eventGroupChatMemberLeft }

/** Fired when a user requests to join a group chat via an join link that requires approval. */
type EventGroupChatJoinRequest = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatJoinRequest'
  rev: string
  convoId: string

  /**
   * The DID of the person requesting to join.
   */
  actorDid: l.DidString

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  createdAt: l.DatetimeString
  groupName: string

  /**
   * The code of the join link used to request joining.
   */
  joinLinkCode: string

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number

  /**
   * Whether the requesting member follows the group owner.
   */
  subjectFollowsOwner: boolean
}

export type { EventGroupChatJoinRequest }

/** Fired when a user requests to join a group chat via an join link that requires approval. */
const eventGroupChatJoinRequest =
  /*#__PURE__*/ l.typedObject<EventGroupChatJoinRequest>(
    $nsid,
    'eventGroupChatJoinRequest',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      convoId: /*#__PURE__*/ l.string(),
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupName: /*#__PURE__*/ l.string(),
      joinLinkCode: /*#__PURE__*/ l.string(),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
      subjectFollowsOwner: /*#__PURE__*/ l.boolean(),
    }),
  )

export { eventGroupChatJoinRequest }

/** Fired when a member is added to a group chat. Note that members are added in the 'request' state. */
type EventGroupChatMemberAdded = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatMemberAdded'
  rev: string
  convoId: string

  /**
   * The DID of the actor performing the action. For this event, same as ownerDid.
   */
  actorDid: l.DidString

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  createdAt: l.DatetimeString
  groupName: string

  /**
   * The DID of the member who was added.
   */
  subjectDid: l.DidString

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number

  /**
   * The number of members who have not yet accepted the convo.
   */
  requestMembersCount: number

  /**
   * Whether the added member follows the group owner.
   */
  subjectFollowsOwner: boolean
}

export type { EventGroupChatMemberAdded }

/** Fired when a member is added to a group chat. Note that members are added in the 'request' state. */
const eventGroupChatMemberAdded =
  /*#__PURE__*/ l.typedObject<EventGroupChatMemberAdded>(
    $nsid,
    'eventGroupChatMemberAdded',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      convoId: /*#__PURE__*/ l.string(),
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupName: /*#__PURE__*/ l.string(),
      subjectDid: /*#__PURE__*/ l.string({ format: 'did' }),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
      requestMembersCount: /*#__PURE__*/ l.integer(),
      subjectFollowsOwner: /*#__PURE__*/ l.boolean(),
    }),
  )

export { eventGroupChatMemberAdded }

/** Fired when a member joins a group chat via an join link that does not require approval. */
type EventGroupChatMemberJoined = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatMemberJoined'
  rev: string
  convoId: string

  /**
   * The DID of the person joining.
   */
  actorDid: l.DidString

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  createdAt: l.DatetimeString
  groupName: string

  /**
   * The code of the join link used to join.
   */
  joinLinkCode: string

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number

  /**
   * Whether the joining member follows the group owner.
   */
  subjectFollowsOwner: boolean
}

export type { EventGroupChatMemberJoined }

/** Fired when a member joins a group chat via an join link that does not require approval. */
const eventGroupChatMemberJoined =
  /*#__PURE__*/ l.typedObject<EventGroupChatMemberJoined>(
    $nsid,
    'eventGroupChatMemberJoined',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      convoId: /*#__PURE__*/ l.string(),
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupName: /*#__PURE__*/ l.string(),
      joinLinkCode: /*#__PURE__*/ l.string(),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
      subjectFollowsOwner: /*#__PURE__*/ l.boolean(),
    }),
  )

export { eventGroupChatMemberJoined }

/** Fired when a join request is approved by the group owner. */
type EventGroupChatJoinRequestApproved = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatJoinRequestApproved'
  rev: string
  convoId: string

  /**
   * The DID of the owner approving the request.
   */
  actorDid: l.DidString

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  createdAt: l.DatetimeString
  groupName: string

  /**
   * The DID of the member whose request was approved.
   */
  subjectDid: l.DidString

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number
}

export type { EventGroupChatJoinRequestApproved }

/** Fired when a join request is approved by the group owner. */
const eventGroupChatJoinRequestApproved =
  /*#__PURE__*/ l.typedObject<EventGroupChatJoinRequestApproved>(
    $nsid,
    'eventGroupChatJoinRequestApproved',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      convoId: /*#__PURE__*/ l.string(),
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupName: /*#__PURE__*/ l.string(),
      subjectDid: /*#__PURE__*/ l.string({ format: 'did' }),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
    }),
  )

export { eventGroupChatJoinRequestApproved }

/** Fired when a join request is rejected by the group owner. */
type EventGroupChatJoinRequestRejected = {
  $type?: 'chat.bsky.moderation.subscribeModEvents#eventGroupChatJoinRequestRejected'
  rev: string
  convoId: string

  /**
   * The DID of the owner rejecting the request.
   */
  actorDid: l.DidString

  /**
   * The DID of the group chat owner.
   */
  ownerDid: l.DidString
  createdAt: l.DatetimeString
  groupName: string

  /**
   * The DID of the member whose request was rejected.
   */
  subjectDid: l.DidString

  /**
   * When the group was originally created.
   */
  convoCreatedAt: l.DatetimeString

  /**
   * Current member count at the time of the event.
   */
  groupMemberCount: number
}

export type { EventGroupChatJoinRequestRejected }

/** Fired when a join request is rejected by the group owner. */
const eventGroupChatJoinRequestRejected =
  /*#__PURE__*/ l.typedObject<EventGroupChatJoinRequestRejected>(
    $nsid,
    'eventGroupChatJoinRequestRejected',
    /*#__PURE__*/ l.object({
      rev: /*#__PURE__*/ l.string(),
      convoId: /*#__PURE__*/ l.string(),
      actorDid: /*#__PURE__*/ l.string({ format: 'did' }),
      ownerDid: /*#__PURE__*/ l.string({ format: 'did' }),
      createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupName: /*#__PURE__*/ l.string(),
      subjectDid: /*#__PURE__*/ l.string({ format: 'did' }),
      convoCreatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
      groupMemberCount: /*#__PURE__*/ l.integer(),
    }),
  )

export { eventGroupChatJoinRequestRejected }
